import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

import auth from './modules/auth'
import search from './modules/search'
import window from './modules/window'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    search,
    window
  },
  getters
})

export default store
